import styled from 'styled-components'
import { colors, font } from '@chegg-ui/theme'

export const SaleBadgeContainer = styled.div`
  position: relative;
  font-weight: ${font.weight.bold};
`

export const SaleBadgeLabel = styled.div`
  position: absolute;
  top: 0;
  padding: 25px;
  color: ${colors.white};
  text-align: center;
`
